import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UnitData } from "../../api/models/units";
import api from "../../api";
import MobileSecViewsHeader from "../../components/MobileSecViewsHeader";
import { Button, CircularProgress, Divider } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import IconifyIcon from "../../components/IconifyIcon";
import { showError } from "../../utils/helpers";

const MobileUnitDetails = () => {
  const labels = useAppSelector(selectLabels);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { id: selectedUnitId, prop_id: selectedPropertyId } = useParams<{
    id: string;
    prop_id: string;
  }>();

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [unit, setUnit] = React.useState<UnitData | null>(null);

  const getUnitById = React.useCallback(
    async (unitId: string, propertyId: string) => {
      try {
        setIsLoading(true);
        const response = await api.unitByIdRequest(Number(propertyId), unitId);
        if (response) {
          setUnit(response?.data);
        }
      } catch (error: any) {
        console.error(error);
        const errorMessage = error?.response?.data?.error?.message;
        showError(dispatch, errorMessage ? errorMessage : labels.generic_error);
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, labels.generic_error]
  );

  React.useEffect(() => {
    if (selectedUnitId && selectedPropertyId) {
      getUnitById(selectedUnitId, selectedPropertyId);
    }
  }, [getUnitById, selectedPropertyId, selectedUnitId]);

  return (
    <div className="w-100 h-100 border-box p-8 scroll">
      <div className="mb-4">
        <MobileSecViewsHeader
          title={"Detalles de la unidad"}
          route={"/units"}
        />
      </div>
      <div className="w-100 border-box hidden">
        {isLoading ? (
          <div className="w-100 flex align-items-center justify-content-center mt-12">
            <CircularProgress />
          </div>
        ) : (
          <div className="w-100 border-box flex flex-dir-col gap-4">
            <div
              className="w-100 border-box flex flex-dir-col align-items-center gap-6 p-8"
              style={{
                backgroundColor: "white",
                border: "1px #e0e0e0 solid",
                borderRadius: 6,
              }}
            >
              <div className="w-100 border-box">
                <p className="body-text-md font-w-500">
                  {unit?.name}
                </p>
              </div>
              <Divider className="w-100" />
              <div className="w-100 border-box mt-4">
                <p className="body-text-sm font-w-500 mb-2">
                  {labels.access_points}:
                </p>
                {unit?.access_points &&
                  unit?.access_points.length > 0 &&
                  unit?.access_points.map((item, index) => (
                    <p key={`${item?.id}-${index}`} className="body-text-md">
                      {item?.name}
                    </p>
                  ))}
              </div>
              <div className="w-100 border-box mt-4">
                <p className="body-text-sm font-w-500 mb-3">{labels.users}:</p>
                {unit?.users &&
                  unit?.users.length > 0 &&
                  unit?.users.map((item, index) => (
                    <div
                      key={`${item?.id}-${index}`}
                      className="w-100 border-box py-2 px-4"
                      style={{
                        borderBottom: "1px #e0e0e0 solid",
                        borderRight: "1px #e0e0e0 solid",
                        borderLeft: "1px #e0e0e0 solid",
                        borderTop: index === 0 ? "1px #e0e0e0 solid" : "",
                      }}
                    >
                      <p key={`${item?.id}-${index}`} className="body-text-md">
                        {item?.name}
                      </p>
                    </div>
                  ))}
              </div>
              <div className="w-100 border-box mt-8 mb-4 flex justify-content-center">
                <Button
                  variant="contained"
                  startIcon={<IconifyIcon icon={"tdesign:edit-filled"} />}
                  onClick={() => navigate(`/edit-unit/${selectedUnitId}`)}
                >
                  {labels.edit_unit}
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileUnitDetails;
